import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/Auth';


function OAuthRedirectHandler() {

    const { fetchUser } = useAuth();
    const navigate = useNavigate();

    const hasHandled = useRef(false);
    useEffect( () => {
        if (hasHandled.current) return;
        hasHandled.current = true;
        try {
            fetchUser();
        } catch (error) {
            console.error("Error fetching user data:", error);
        }finally{
            // Redirect to the dashboard after fetching user data
            navigate('/dashboard');
        }
    }, []);

    return (
        <div>
            <h1>Redirecting...</h1>
        </div>
    );
}

export default OAuthRedirectHandler;